import { ethers } from 'ethers'

import { getWalletSnapshot } from './walletProviders'

export function getSelectedWalletEthersProvider(expectedChainId) {
    const snapshot = getWalletSnapshot()
    if (!snapshot?.account || !snapshot?.provider) {
        throw new Error('No selected wallet provider is connected')
    }

    if (expectedChainId && Number(snapshot.chainId) !== Number(expectedChainId)) {
        throw new Error('Selected wallet is connected to the wrong network')
    }

    return new ethers.providers.Web3Provider(snapshot.provider)
}
